<template>
<div class="content">
  <h1><Icon type="ios-calculator" /> {{ pageTitle }}</h1>
  <div class="content-body table-wrapper" data-test-id="cost-estimator-search">
    <div class="block">
      <div class="assembled-part-cost-estimators-finder--filter" style="display: flex; flex-flow: row; justify-content: flex-start; gap: 10px;">
        <Input v-model="filter.title" :placeholder="$t('title')"></Input>
        <ManufacturerPartPicker v-model="filter.manufacturer_part_id"></ManufacturerPartPicker>
        <Button type="primary" @click="findAssembledPartCostEstimators">{{ $t('order.search_go') }}</Button>
      </div>
      <div style="margin: 20px 0"></div>
      <vxe-toolbar>
        <template #buttons>
          <div class="text-align-right">
            <Button icon="md-add" type="primary" @click="handleShowCreateForm">{{ $t('cost.new_assembled_part_cost_estimator') }}</Button>
          </div>
        </template>
      </vxe-toolbar>
      <vxe-table :data="assembledPartCostEstimatorsList.data" border size="mini">
        <vxe-table-column type="seq" width="40" align="center"></vxe-table-column>
        <vxe-table-column field="title" :title="$t('title')" :min-width="300"></vxe-table-column>
        <vxe-table-column field="manufacturer_part.display_name" :title="$t('cost.manufacturer_part')" :width="320"></vxe-table-column>
        <vxe-table-column field="quantity" :title="$t('quantity')" width="100" align="right"></vxe-table-column>
        <vxe-table-column field="currency" :title="$t('currency')" width="80" align="center"></vxe-table-column>
        <vxe-table-column field="created_at" :title="$t('created_at')" align="right" width="160"></vxe-table-column>
        <vxe-table-column :title="$t('order.actions')" width="130" align="center">
          <template #default="{ row }">
            <router-link :to="{ name: 'menu.estimators.assembled_part_costed_bom_list', params: { id: row.id } }">{{ $t('edit') }}</router-link>
            <a style="margin-left: 7px;" @click="handleDelete(row)">{{ $t('remove') }}</a>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
            border
            icon-prev-page="fa fa-angle-left"
            icon-jump-prev="fa fa-angle-double-left"
            icon-jump-next="fa fa-angle-double-right"
            icon-next-page="fa fa-angle-right"
            icon-jump-more="fa fa-ellipsis-h"
            :loading="loading"
            :current-page="pager.current_page"
            :page-size="pager.per_page"
            :total="pager.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handlePageChange">
          </vxe-pager>
    </div>
  </div>
  <Drawer :title="$t('cost.assembled_part_cost_estimator_info')"
          v-model="showCreateForm"
          :mask-closable="false"
          width="540">
    <AssembledPartCostEstimatorForm ref="assembledPartCostEstimatorForm" @on-saved="handleSaved"></AssembledPartCostEstimatorForm>
  </Drawer>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AssembledPartCostEstimatorForm from './components/forms/assembled-part-cost-estimator-form'
import ManufacturerPartPicker from '@/view/part/components/manufacturer-part-picker'
export default {
  name: 'AssembledPartCostEstmators',
  components: {
    AssembledPartCostEstimatorForm,
    ManufacturerPartPicker
  },
  data () {
    return {
      pager: {
        current_page: 1,
        per_page: 15,
        page: 1
      },
      loading: true,
      filter: {},
      showCreateForm: false
    }
  },
  mounted () {
    this.findAssembledPartCostEstimators()
  },
  computed: {
    ...mapGetters([
      'assembledPartCostEstimatorsList'
    ]),
    pageTitle () {
      document.title = this.$t('menu.estimators.title') + ' - ' + this.$t('menu.estimators.assembled_part_cost')
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'loadAssembledPartCostEstimators',
      'deleteAssembledPartCostEstimator'
    ]),
    findAssembledPartCostEstimators () {
      this.loading = true
      this.loadAssembledPartCostEstimators(this.buildQuery()).then(resp => {
        this.pager = (({ per_page, current_page, total }) => ({ per_page, current_page, total }))(resp.data.meta)
      }).finally(() => {
        this.loading = false
      })
    },
    buildQuery () {
      let search = Object.entries(this.filter).filter(([_, v]) => v).map((e) => {
        return e.join(':')
      }).join(';')

      return Object.assign({}, { search: search, searchJoin: 'and' }, this.pager)
    },
    handleShowCreateForm (row = null) {
      this.showCreateForm = true
    },
    handleSaved(result) {
      this.showCreateForm = false
      this.$router.push({ name: 'menu.estimators.assembled_part_costed_bom_list', params: { id: result.id } })
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.pager.page = currentPage
      this.pager.per_page = pageSize
      this.findAssembledPartCostEstimators()
    },
    handleDelete (row) {
      this.deleteAssembledPartCostEstimator(row.id)
    }
  }
}
</script>
